import React, { useState } from 'react';
import { motion, AnimatePresence } from "framer-motion";

const dropdownItems = {
  "PROJECT": ["ABATTOIR", "Apples", "Avocado", "Bananas", "Beans", "Cabbages", "Kale", "Mangoes", "Onions", "Passion Fruits", "Papaya", "Potatoes", "Strawberries", "Tomatoes", "Watermelon"],
};

const Dropdown = ({ label, items, type, isProjectDropdown, bottomLabel }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(items[0]);

  return (
  <a href='/Log_in'>
      <div className="flex flex-col w-full relative">
      <label className="md:text-[32px] font-bold text-[6px] text-black mb-1 md:mb-2">
        {label}
      </label>

      <div className="flex relative  w-full">
        {/* Dropdown Button */}
        <button
          onClick={() => setIsOpen((prev) => !prev)}
          className={`w-full h-[30px] md:h-[71px] ${
            isProjectDropdown ? "bg-[#03897B]" : "bg-[#03897B]"
          } text-white font-semibold flex md:px-3 items-center px-2 rounded-l-[5px]`}
        >
          <span className="md:text-[18px] md:px-2 text-[6px] md:mt-0 mt-[2px]">{selected}</span>
        </button>

        {/* Icon Box */}
        <div
          className={`w-[30px] h-[30px] md:h-[71px] md:w-[81px] ${
            isProjectDropdown ? "bg-[#152C24]" : "bg-[#152C24]"
          } text-white flex justify-center items-center rounded-r-[5px] -ml-2  cursor-pointer`}
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745963296/Expand_down_14_gvfcpo.png"
            alt="expand"
            className="w-4 h-4 md:w-12 md:h-[48px]"
          />
        </div>
      </div>

      {/* Dropdown List */}
      <AnimatePresence>
        {isOpen && (
          <motion.ul
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="absolute top-full mt-1 left-0 z-50 w-full bg-white/90 rounded-lg shadow-lg"
          >
            {items.map((item, index) => (
              <li
                key={index}
                onClick={() => {
                  setSelected(item);
                  setIsOpen(false);
                }}
                className="md:p-3 p-1 bg-[#CFD7D7] md:mt-1 md:text-[18px] text-[10px] rounded-md hover:bg-[#afafaf] cursor-pointer flex items-center"
              >
                <span className="text-black">{item}</span>
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </div>
  </a>
  );
};

const Project = () => {
  const keys = Object.keys(dropdownItems);

  return (
    <div className="flex flex-row gap-2 w-full md:mb-10 mb-6 mt-6 md:mt-16 font-Inter">
      <div className="w-full">
        {keys.map((type, index) => {
          const customLabels = {
            Crop: "Crop Report",
            Livestock: "Livestock Report",
            Type: "Type of Report",
          };

          const bottomLabels = [
            "Select administrative location",
            "Select value chain",
            "Select administrative location",
            "Viewmore",
          ];

          const displayLabel = customLabels[type] || type;
          const isProjectDropdown = index === keys.length - 1;

          return (
            <div key={type} className="w-full">
              <Dropdown
                label={displayLabel}
                items={dropdownItems[type]}
                type={type}
                isProjectDropdown={isProjectDropdown}
                bottomLabel={bottomLabels[index]}
              />
            </div>
          );
        })}
      </div>

      {/* VIEW MORE Section */}
      <div className="flex w-full md:mt-14 mt-3">
        <p className="w-full md:text-[18px] text-[5px] bg-[#152C24] text-white px-2 md:px-6 md:py-[9px] h-[30px] md:h-[71px] font-medium flex items-center rounded-tl-md md:rounded-tl-[5px] rounded-bl-md md:rounded-bl-[5px]">
          VIEW MORE
        </p>
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745957393/Expand_right_12_a0uw4a.png"
          alt="Expand"
          className="hidden md:flex md:w-[80px] md:h-[71px] object-contain rounded-tr-[5px] rounded-br-[5px] bg-[#F38323] px-1 py-4"
        />
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
          alt="Expand"
          className="md:hidden flex w-[20px] h-[30px] object-contain bg-[#152C24] px-[2px] py-[1px] rounded-tr-md rounded-br-md"
        />
      </div>
    </div>
  );
};

export default Project;
